import axios from 'axios'
import { aesEncrypt, aesDecrypt,getPath } from '../utils/aes'
// import LuckyCookie from '@/utils/lucky-cookies'
import Moment from 'moment'
import { downloadFile } from '@/utils'
import { Loading, Message } from 'element-ui'

let loadingInstance = null
let requestNum = 0

const addLoading = () => {
  // 增加loading 如果pending请求数量等于1，弹出loading, 防止重复弹出
  // requestNum++
  // if (requestNum == 1) {
  //   loadingInstance = Loading.service({
  //     text: 'loading...',
  //     spinner: 'el-icon-loading',
  //     background: '#6000C1',
  //   })
  // }
}

const cancelLoading = () => {
  // 取消loading 如果pending请求数量等于0，关闭loading
  requestNum--
  if (requestNum === 0) loadingInstance.close()
}

const instance = axios.create({
  timeout: 500000, //超时配置
  // baseURL: location.protocol + '//' + location.host+ '/api/app',
  baseURL: '/api/app',
  withCredentials: true, //跨域携带cookie
  // ...config, // 自定义配置覆盖基本配置
})

// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    const { loading = true } = config
    try {
      if (localStorage.getItem('token')) {
        config.headers.Authorization = localStorage.getItem('token')
      }
    } catch (error) {}

    if (loading) addLoading()
    config.headers['Accept-Language'] = 'en_Us'
    if (config.method === 'post' || config.method === 'put') {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
      // config.data = aesEncrypt(config.data)
    }
     // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?';
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof(value) !== "undefined") {
          if (typeof value === 'object') {
            for (const key of Object.keys(value)) {
              let params = propName + '[' + key + ']';
              var subPart = encodeURIComponent(params) + "=";
              url += subPart + encodeURIComponent(value[key]) + "&";
            }
          } else {
            url += part + encodeURIComponent(value) + "&";
          }
        }
      }
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    // config.headers['Version'] = process.env.VUE_APP_BASE_VERSION // version
    // config.headers['CsrfToken'] = aesEncrypt(Moment().format('YYYY-MM-DD HH:mm:ss'))
    // try {
    //   if (LuckyCookie.get('csrfToken')) {
    //     config.headers['Csrftoken'] = LuckyCookie.get('csrfToken')
    //   }
    // } catch (error) {}

    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    const { loading = true } = response.config
    if (loading) cancelLoading()
    const { code, msg } = response.data
    // config设置responseType为blob 处理文件下载
    if (response.data instanceof Blob) {
      return downloadFile(response)
    } else {
      if (code == 200) {
        response.data.data = response.data.data
        // console.log(response.data.data);
        return response.data.data
      } else if (code == 401 || code == 409) {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        location.href = getPath("/login")
      } else{
        Message.error(msg)
        return Promise.reject(msg)
      }
    }
  },
  function (error) {
    console.log(error)
    // 对响应错误做点什么
    console.log('error-response:', error.response)
    console.log('error-config:', error.config)
    console.log('error-request:', error.request)
    const { loading = true } = error.config
    if (loading) cancelLoading()
    // if (error.response) {
    //   let { msg,code } = error.response.data
    //   if (msg === '请勿跨站请求' || code==400) {
    //     LuckyCookie.remove('csrfToken')
    //     window.location.reload()
    //   }
    // }
    return Promise.reject(error)
  }
)

// const serviceBefore = async (options) => {
//   console.log('serviceBefore, options:', options)
//   console.log(instance(options), '1 11')
//   if (!LuckyCookie.get('csrfToken')) {
//     const { csrfToken, csrfTokenEndTimeStamp } = await instance({
//       url: '/csrf/randomNumber',
//       method: 'post',
//     })
//     LuckyCookie.set('csrfToken', csrfToken, csrfTokenEndTimeStamp)
//   }

//   return await instance(options)
// }

export default instance
